import { combineReducers } from "redux"
import riwayatReducer from "./riwayat/riwayatReducer"
import klaimReducer from "./klaim/klaimReducer"
import detailReducer from "./detail/detailReducer"
import kalogReducer from "./kalog/kalogReducer"
import claimReconReducer from "./claim-recon/claimReconReducer"

const rootReducer = combineReducers({
  riwayatStore: riwayatReducer,
  klaimStore: klaimReducer,
  detailStore: detailReducer,
  kalogStore: kalogReducer,
  claimReconStore: claimReconReducer,
})

export default rootReducer
